import WeatherBlockView from './View';
import WeatherBlockEdit from './Edit';
import WeatherSVG from '@plone/volto/icons/world.svg';
import { weatherBlockSchema } from './schema';

const block = {
  id: 'weather',
  title: 'Weather Block',
  icon: WeatherSVG,
  group: 'common',
  view: WeatherBlockView,
  edit: WeatherBlockEdit,
  blockSchema: weatherBlockSchema,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1 as const,
};

export default block;
